module.exports = __webpack_public_path__ + "a45dc5f293cab8c13990e80b605d54f3.svg";